module.exports = __webpack_public_path__ + "img/telescope.b1a23b20.svg";